import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { type TranslateServerSideState, TranslateStep, TranslateContentType } from '../../types';
import type { GetTranslateServerSideStateService } from '../get-translate-task-status-service';
import { GetTaskDetail } from '@/infrastructure/api-functions/core-drafting-api/get-task-detail-api';
import { TaskDateFormatter } from '@/services/date-format/task-date-formatter';
import { TranslateServerSideModel } from '../../models/translate-server-side-model';
import { OriginalInputModel } from '../../models/original-input-model';

@injectable()
export class GetTranslateServerSideStateServiceImpl implements GetTranslateServerSideStateService {
    constructor(
        @inject(GetTaskDetail)
        private readonly _getTaskDetail: GetTaskDetail<TranslateContentType, TranslateStep>,
        @inject(TaskDateFormatter)
        private readonly _taskDateFormatter: TaskDateFormatter,
        @inject(TranslateServerSideModel)
        private readonly _translateServerSideModel: TranslateServerSideModel,
        @inject(OriginalInputModel)
        private readonly _originalInputModel: OriginalInputModel,
    ) {}

    async pullTranslateServerSideState(taskId: string): Promise<void> {
        const state = await this.getTranslateServerSideState(taskId);
        this._translateServerSideModel.update(() => state);
    }

    getTranslateServerSideState(taskId: string): Promise<TranslateServerSideState> {
        return this._getTaskStatusRepository(taskId);
    }

    private _getTaskStatusRepository(taskId: string): Promise<TranslateServerSideState> {
        return this._getTaskDetail.getTaskDetail(taskId).then((taskDetail) => {
            const createdAt = this._taskDateFormatter.format(taskDetail.created_at);
            const updatedAt = this._taskDateFormatter.format(taskDetail.updated_at);
            const result: TranslateServerSideState = {
                taskStatus: taskDetail.task_status,
                currentStep: taskDetail.current_step,
                stepDetail: {},
                createdAt,
                updatedAt,
            };
            this._originalInputModel.update((oldData) => {
                return {
                    ...oldData,
                    input: taskDetail.user_input,
                };
            });
            return result;
        });
    }
}
